// Libs
import { useState } from "react";

// Data
import * as itTexts from "./i18n/it";
import * as enTexts from "./i18n/en";

// Enums
import { ENUM_LANGUAGES } from "../../enums";

const appText: { [key: number]: any } = {
    [ENUM_LANGUAGES.IT]: itTexts,
    [ENUM_LANGUAGES.EN]: enTexts
};

const useLanguageHook = (langForText: number = ENUM_LANGUAGES.IT) => {
    const [state, setState] = useState({
        langForText: langForText,
        appText: appText[langForText]
    });

    /**
    * Changes the language settings for text
    * @param {string} langForText either `en`, `it`, `fr`, `de`
    */
    const setLangForText = (langForText: number): void => {
        setState((oldState) => {
            const newState = { ...oldState };
            newState.langForText = langForText;
            newState.appText = appText[langForText];
            return newState;
        });
    };

    return [
        state.appText,
        state.langForText,
        setLangForText
    ] as const;
};

export default useLanguageHook;
